import React from 'react';
import { Box, Typography, Grid, Divider, Link } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { kollalogowhite } from '../assets';
import { useNavigate } from 'react-router-dom';
import TwitterIcon from '@mui/icons-material/Twitter';


const linksdata = [
  { title: 'Home', url: '/' },
  // { title: 'About Us', url: '/about' },
  { title: 'Luxor Exclusive', url: '/luxor-exclusive' },
  { title: 'Luxuria', url: '/luxuria' },
  { title: 'Blogs', url: '/blog' },
  { title: 'Contact Us', url: '/contactus' },
];

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const socialLinks = [
    { Icon: WhatsAppIcon, url: 'https://wa.me/+916309994444' },
    { Icon: InstagramIcon, url: 'https://www.instagram.com/kolla_group/' },
    { Icon: FacebookIcon, url: 'https://www.facebook.com/kollahousing' },
    { Icon: YouTubeIcon, url: 'https://www.youtube.com/@KOLLA_Group' },
    { Icon: LinkedInIcon, url: 'https://www.linkedin.com/company/kolla_group/' },
    { Icon: TwitterIcon, url: 'https://x.com/kollagroup' },

  ];

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: "#191818",
        color: 'white',
        py: 8,
        px: { xs: 3, md: 10 },
      }}
    >
      <Grid container spacing={6} sx={{
      }}>
        {/* Left Section - Company Info */}
        <Grid item xs={12} md={4.5}>
          <img src={kollalogowhite} alt="Best apartments in Hyderabad by Kolla Group" style={{ width: 100, userSelect: 'none', marginBottom: "10px" }} />
          <Typography variant="body2" sx={{ color: 'gray', mt: 1 , lineHeight: 1.85 }}>
            KMR Estates & Builders Pvt. Ltd.<br/>
            KOLLA Developers and Builders Pvt. Ltd.<br/>
            WINCON Housing Pvt. Ltd.<br/>
          </Typography>
          {/* <Typography variant="body2" sx={{ color: 'gray', mt: 1 }}>
            <strong>Corporate Office : </strong>
            1175,
            Road No. 56, <br/>Jubilee Hills,
            Hyderabad-500033
          </Typography> */}

          {/* Social Icons */}
          <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
            {socialLinks.map(({ Icon, url }, index) => (
              <Box
                key={index}
                sx={{
                  p: 1,
                  bgcolor: '#222',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  transition: '0.3s',
                  '&:hover': { bgcolor: '#444' },
                }}
                onClick={() => window.open(url, '_blank')}
              >
                <Icon sx={{ color: 'white' }} />
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Middle Section - Links */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" fontWeight="600" gutterBottom>
            LINKS
          </Typography>
          {linksdata.map((t) => (
            <Link
              key={t.title}
              variant="body2"
              onClick={() => navigate(t.url)}
              sx={{
                display: 'block',
                color: 'gray',
                cursor: 'pointer',
                my: 1,
                textDecoration: 'none',
                '&:hover': { color: 'white' },
              }}
            >
              {t.title}
            </Link>
          ))}
        </Grid>

        {/* Right Section - Instagram */}
        {/* <Grid item xs={12} md={3}>
          <Typography variant="h6" fontWeight="600" gutterBottom>
            INSTAGRAM
          </Typography>
            <Box sx={{ mt: 2 }}>
            <iframe
              src="https://www.instagram.com/kolla_group/embed"
              width="100%"
              height="300"
              frameBorder="0"
              scrolling="no"
              allowTransparency={true}
              style={{
              border: 'none',
              overflow: 'hidden',
              width: '100%',
              height: '300px',
              }}
              title="Instagram Embed"
            ></iframe>
            </Box>
        </Grid> */}

        {/* Contact Section */}
        <Grid item xs={12} md={4.5}>
          <Typography variant="h6" fontWeight="600" gutterBottom sx={{ mb: 1 }}>
            CALL US
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
            <PhoneIcon sx={{ color: 'primary.main', mr: 1 }} />
            <Typography
              variant="body1"
              sx={{ color: 'primary.main', fontWeight: '600', cursor: 'pointer' }}
              onClick={() => window.open('https://wa.me/917995999771', '_blank')}
            >
              +91 799 599 9771
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <EmailIcon sx={{ color: 'primary.main', mr: 1 }} />
            <Typography
              variant="body1"
              sx={{ color: 'primary.main', fontWeight: '600', cursor: 'pointer' }}
              onClick={() => window.open('mailto:contact@kollagroup.com', '_blank')}
            >
              contact@kollagroup.com
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <LocationOnIcon sx={{ color: 'primary.main', mr: 1, mt: 0.5 }} />
            <Typography variant="body2" sx={{ color: 'gray', lineHeight: 1.85 }}>
              <strong>Corporate Office : </strong>
              Plot No. #1175, Road No. 56, <br /> Jubilee Hills, Hyderabad-500033
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Divider and Copyright  */}
        <Divider sx={{ my: 2, bgcolor: 'gray' }} />
        <Box sx={{ textAlign: 'center', color: 'gray' }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} <b>Kolla Group</b>. All rights reserved. 
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <Link
              onClick={() => navigate('/privacy-policy')}
              sx={{ color: 'gray', textDecoration: 'none', cursor: 'pointer', '&:hover': { color: 'white' } }}
            >
              Designed by{' '}
              <Link
                href="https://dezignshark.com"
                target="_blank"
                sx={{ color: 'gray', textDecoration: 'none', '&:hover': { color: 'white' } }}
              >
                <b>Dezign Shark</b>
              </Link>
              {' | '}
              <Link
                onClick={() => navigate('/privacy-policy')}
                sx={{
                  color: 'gray',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Privacy Policy
              </Link>
            </Link>
          </Typography>

        </Box>
    </Box>
  );
};

export default Footer;






















